import React from 'react';
import ReactDOM from 'react-dom/client';
import "./impersonationBootstrap";   // اختياري لكنه مفيد
import "./axiosImpersonationPatch";  // المهم

import App from './App';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import'bootstrap/dist/js/bootstrap.bundle.min.js';
// import 'bootstrap-rtl/dist/css/bootstrap-rtl.min.css';
import'@fortawesome/fontawesome-free/css/all.min.css';
import './index.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { HelmetProvider } from 'react-helmet-async';
import UserContextProvider from './Context/UserContext';
import './i18n'; // Import the i18n configuration
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import ErrorBoundary from './Components/ErrorBoundary/ErrorBoundary';
import { setupGlobalErrorHandlers } from './utils/globalErrorHandler';
// import{ReactQueryDevtools} from 'react-query/devtools'

// Setup global error handlers
setupGlobalErrorHandlers();

// Disable service worker caching so users always get fresh deploy/data.
serviceWorkerRegistration.unregister();

if ('serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    try {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.map((registration) => registration.unregister()));

      if ('caches' in window) {
        const cacheKeys = await window.caches.keys();
        await Promise.all(cacheKeys.map((cacheKey) => window.caches.delete(cacheKey)));
      }
    } catch (error) {
      console.error('Failed to clear old service worker/cache data:', error);
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));

let queryClient = new QueryClient();

root.render(
    <ErrorBoundary>
        <HelmetProvider>
            <QueryClientProvider client={queryClient}>
                <UserContextProvider>
                    <App />
                    {/* <ReactQueryDevtools initialIsOpen="false" position='bottom-right'  /> */}
                </UserContextProvider>
            </QueryClientProvider>
        </HelmetProvider>
    </ErrorBoundary>
);